export const pageOrientationSelectTestIds = {
  container: 'page-orientation-container',
  select: 'document-settings-page-orientation-select',
};
